import React, { useState, useCallback, useEffect } from 'react'
import ContentLoader from 'react-content-loader'

import { BsChevronLeft, BsChevronRight } from 'react-icons/bs'

import { NavigationWrapper, Container } from './styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'
import { TSwrLesson } from '../../hooks/use-get-lesson'
import { TSwrMenuContent } from '../../hooks/use-get-menu-content'
import TooltipWrapper from 'pages/MyQuestionBooks/components/TooltipWrapper'

interface IProps {
  handleContentNavigate?: (type: 'previous' | 'next' | 'next_lesson') => void
  swrMenuContent: TSwrMenuContent
  swrLesson: TSwrLesson
  typeContent: string
}

const Footer: React.FC<IProps> = (props) => {
  const { data, isLoading } = props.swrLesson
  const course = props.swrMenuContent.isLoading ? null : props.swrMenuContent.data.course
  const previousChapterName = props.swrLesson.isLoading ? null : data.chapter?.previous?.name
  const nextChapterName = props.swrLesson.isLoading ? null : data.chapter?.next?.name
  const nextLessonId = props.swrLesson.isLoading ? null : data.next?._id
  const isLastLesson = props.swrLesson.isLoading ? false : data.chapter?.isLast
  const isFirstChapter = props.swrLesson.isLoading ? false : data.chapter?.isFirst
  const isLastChapter = props.swrLesson.isLoading ? false : data.chapter?.isLast
  const courseInfos = course

  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const [length, setLength] = useState<number>()
  useEffect(() => {
    if (window.innerWidth >= 1080) {
      setLength(50)
    } else {
      setLength(35)
    }
  }, [])

  const finishClass = useCallback(() => {
    if (isLastLesson && nextLessonId) return 'Finalizar aula'
    if (isLastLesson && !nextLessonId) return 'Finalizar módulo'
  }, [isLastLesson, nextLessonId])

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
    width: 160,
    height: 20,
    viewBox: '0 0 160 20',
  }

  const isMobileView = window.matchMedia('(max-width: 768px)').matches

  return (
    <Container typeContent={props.typeContent}>
      <NavigationWrapper className="footer" typeContent={props.typeContent}>
        {!isFirstChapter ? (
          <TooltipWrapper text="Anterior" position="right">
            <button className="left" onClick={() => props.handleContentNavigate('previous')}>
              <div className="iconLeft">
                <BsChevronLeft size={14} />
              </div>
              <div>
                <div className="textLeft">
                  {isLoading ? (
                    <ContentLoader {...LoaderProps}>
                      <rect x="0" y="5" rx="3" ry="3" width="150" height="11" />
                    </ContentLoader>
                  ) : isMobileView ? (
                    'Anterior'
                  ) : previousChapterName?.length > length ? (
                    previousChapterName.substring(0, length) + '...'
                  ) : (
                    previousChapterName
                  )}
                </div>
              </div>
            </button>
          </TooltipWrapper>
        ) : (
          <button disabled style={{ cursor: 'not-allowed', visibility: 'hidden' }}>
            <BsChevronLeft size={14} />
          </button>
        )}
        {!isLastChapter ? (
          <button className="right" onClick={() => props.handleContentNavigate('next')}>
            <TooltipWrapper text="Próximo" position="left">
              <div>
                <div className="textRight">
                  {isLoading ? (
                    <ContentLoader {...LoaderProps}>
                      <rect x="0" y="5" rx="3" ry="3" width="150" height="11" />
                    </ContentLoader>
                  ) : isMobileView ? (
                    'Próximo'
                  ) : nextChapterName?.length > length ? (
                    nextChapterName.substring(0, length) + '...'
                  ) : (
                    nextChapterName
                  )}
                </div>
              </div>
            </TooltipWrapper>
            <div className="iconRight">
              <BsChevronRight size={14} color={isDarkMode ? '#FFFFFF' : '#1A1A1A'} />
            </div>
          </button>
        ) : (
          <button
            className="right"
            onClick={() => (courseInfos?.isFreemium ? '' : props.handleContentNavigate('next'))}
          >
            <div className="textRight">
              <span className="onlyDesk"> </span>
              <span className="onlyMobile"> </span>
              {!courseInfos?.isFreemium && <div>{finishClass()}</div>}
            </div>
            <div className="iconRight">
              <BsChevronRight size={14} color={isDarkMode ? '#FFFFFF' : '#1A1A1A'} />
            </div>
          </button>
        )}
      </NavigationWrapper>
    </Container>
  )
}

export default Footer
